import { render, staticRenderFns } from "./SelfTestsModal.vue?vue&type=template&id=22770510&scoped=true&"
import script from "./SelfTestsModal.vue?vue&type=script&lang=js&"
export * from "./SelfTestsModal.vue?vue&type=script&lang=js&"
import style0 from "./SelfTestsModal.vue?vue&type=style&index=0&id=22770510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22770510",
  null
  
)

export default component.exports